import styled from 'styled-components';
import { transitionDuration, transitionTiming, zIndexTop } from '~/styles/tokens';

export const HeadlineStyle = styled.div`
	sup {
		font-size: 10px !important;
	}

	.loader-indicator {
		position: absolute;
		left: 0;
		top: 0;
		z-index: ${zIndexTop};
		width: 100%;
		* {
			height: 2px;
		}
	}
	.headline__main,
	.main-headline__sub {
		transition-timing-function: ${transitionTiming};
		transition-duration: ${transitionDuration}ms;
		transition-property: padding-bottom, top;
	}
	.headline__main {
		font-size: 20px;
		line-height: 32px;
		margin-top: 0;
		margin-bottom: 0;
	}

	.headline__sub {
		font-size: 16px;
		margin-block-end: 0;
		line-height: 24px;
		margin-bottom: 0;
	}

	.headline__model {
		font-stretch: 130%;
	}
`;
